import React, { Fragment } from 'react';
import { Intro, CompleteSentence } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-4.svg';

const data = [
  {
    beforeChoice:
      'MyPlate recommends that people choose the correct amount of foods each day from',
    afterChoice: 'food groups.',
    choices: ['5', '3']
  },
  {
    beforeChoice: 'Nuts and seeds are a surprise source of',
    afterChoice: '.',
    choices: ['protein', 'vegetables']
  }
];

const correctInput = {
  0: '5',
  1: 'protein'
};

const feedback = {
  success: {
    title: 'Nice!',
    body: ''
  },
  error: {
    title: 'Not the best answer.',
    body: ''
  },
  retry: {
    title: 'Not quite, give it another try',
    body: ''
  }
};

export default {
  title: 'Question 4',
  path: '/challenge/question-4',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select the word/phrase that best completes each sentence."
        img={img}
      />
      <CompleteSentence
        data={data}
        feedback={feedback}
        correctInput={correctInput}
        score={2}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/Question4.js